// @ts-ignore
import blockedPage from '@/assets/images/blocked_page.png';
import { Flex, FlexProps, Heading, Box } from '@blockanalitica/ui';
import styled, { css } from 'styled-components';
import { WebsiteUnavailableIcon } from '@/components';

const ContentContainer = styled(Flex)<FlexProps>`
  max-width: 600px;
  height: 150px;
  position: absolute;

  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
  z-index: 50;

  ${(props) => css`
    padding: ${props.theme.space.m};
    border-radius: ${props.theme.sizes[3]};
    background: ${props.theme.colors.black65};
  `}
`;
const AlphaBackgroundLayer = styled.div`
  display: block;
  position: fixed;
  inset: 0;
  background-color: ${(props) => props.theme.colors.black65};
  z-index: 49;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
`;

export default function BlockedPage() {
  return (
    <Flex justifyContent="center">
      <ContentContainer flexDirection="row" gap="s" justifyContent="center">
        <WebsiteUnavailableIcon size={40} />
        <Flex flexDirection="column" gap="m">
          <Heading size="2">
            <Box fontSize="5">A VPN has been detected</Box>
          </Heading>

          <Flex flexDirection="column" gap="xs">
            <p>
              VPNs are blocked to meet legal and regulatory compliance
              obligations in connection with access from certain jurisdictions.
              For more information refer to the{' '}
              <a
                href="https://docs.sky.money/legal-terms"
                target="_blank"
                rel="noreferrer">
                Terms of Use
              </a>
              .
              <br />
            </p>
            <p>Apologies for any inconvenience.</p>
          </Flex>
        </Flex>
      </ContentContainer>
      <img src={blockedPage} />

      <AlphaBackgroundLayer />
    </Flex>
  );
}
